import { MutationTree } from "vuex";
import { IntAddCanidates } from "./types";

export const mutations: MutationTree<IntAddCanidates> = {
  ADD_CANDIDATES_FULLFILED(state, payload: []) {
    state.data = payload;
  },
  ADD_CANDIDATES_REJECTED(state, payload: string) {
    state.error = payload;
  },
  RESET_CANDIDATES(state) {
    state.data = [];
  },
};
